import React, { Component } from 'react';
import { connect } from 'react-redux';
import ManageUserForm from "./ManageUserForm";
import {
    deleteUser,
    deleteUserSapAccount,
    getExclusionList,
    getUserSapAccounts,
    saveUser,
    updateExclusionList
} from "../../requests/UserRequests";
import PropTypes from 'prop-types';
import LinkedSapAccounts from "./LinkedSapAccounts";
import { Link, withRouter } from 'react-router-dom';
import RegistrationRequestDetails from "../settings-page/registration-requests/RegistrationRequestDetails";
import { markRegistrationCompleted } from "../../requests/RegistrationRequests";
import ExclusionList from "./exclusions/ExclusionList";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { Modal } from "react-bootstrap";

export class ManageUserPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: {
                login: "",
                firstName: "",
                lastName: "",
                company: "",
                email: "",
                status: "active",
                //userProfileId: "",
                createdDate: "",
                lastLoginDate: "",
                numLogins: "",
                lastPasswordChange: "",
                primaryAcctType: "",
                userRole: "",
            },
            request: null,
            show: false,
        };
        this.saveUser = this.saveUser.bind(this);
        this.deleteUser = this.deleteUser.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleShow = this.handleShow.bind(this);
    }


    handleClose = () => this.setState({ show: false });
    handleShow = () => this.setState({ show: true });

    componentDidMount() {
        this.loadUser();
        if (this.props.fromRequest) {
            this.props.getRegistrationRequest(this.props.fromRequest).then((request) => {
                this.setState({
                    request: request,
                    user: {
                        ...this.state.user,
                        firstName: request.firstName,
                        lastName: request.lastName,
                        company: request.company,
                        email: request.email,
                    }
                });
            });
        }
    }

    loadUser() {
        if (this.props.getUser) {
            this.props.getUser().then((user) => {
                this.setState({ user: user });
                return user;
            })
        }
    }

    deleteUser() {
        deleteUser(this.state.user.UserId).then(() => {
            this.props.history.push("/settings/users");
        })
    }

    saveUser(form) {
        return saveUser(form).then((user) => {
            if (this.state.request) {
                markRegistrationCompleted(this.state.request.registrationRequestId);
            }
            this.setState({ user: user });
        });
    }

    render() {
        const firstName = this.state.user && this.state.user.FirstName ? this.state.user.FirstName : '';
        const lastName = this.state.user && this.state.user.LastName ? this.state.user.LastName : '';
        //return (
        //    <div className={"container"}>
        //        <div
        //            className="modal fade"
        //            id="confirmDelete"
        //            tabIndex="-1"
        //            role="dialog"
        //            aria-labelledby="confirmDeleteLabel"
        //            aria-hidden="true"
        //        >
        //            <div className="modal-dialog" role="document">
        //                <div className="modal-content">
        //                    <div className="modal-header">
        //                        <h5 className="modal-title" id="confirmDeleteLabel">
        //                            Confirm Deletion
        //                        </h5>
        //                        <button
        //                            type="button"
        //                            className="close"
        //                            data-dismiss="modal"
        //                            aria-label="Close"
        //                        >
        //                            <span aria-hidden="true">&times;</span>
        //                        </button>
        //                    </div>
        //                    <div className="modal-body">
        //                        Are you sure you want to delete this use? This can not be undone.
        //                    </div>
        //                    <div className="modal-footer">
        //                        <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={this.deleteUser}>
        //                            Ok
        //                        </button>
        //                        <button
        //                            type="button"
        //                            className="btn btn-secondary"
        //                            data-dismiss="modal"
        //                        >
        //                            Cancel
        //                        </button>
        //                    </div>
        //                </div>
        //            </div>
        //        </div>

        //        <div className="row">
        //            <div className="col-4">
        //                <Link to="/settings/users" className="btn button-back">
        //                    <FontAwesomeIcon icon={faAngleLeft} className={"button-back-text"} /> &nbsp;
        //                    <span className="button-back-text">Back To Users</span>
        //                </Link>
        //            </div>
        //            <div className="col-4 text-center">
        //                <span className="user-name">{`${firstName}${' '}${lastName}`}</span>
        //            </div>
        //        </div>
        //        {this.state.request && <div className="row mt-2">
        //            <div className={"col-12"}>
        //                <div className="card">
        //                    <RegistrationRequestDetails request={this.state.request} />
        //                </div>
        //            </div>
        //        </div>}
        //        <div className="row mt-2">
        //            <div className={"col-12"}>
        //                <div className="card">
        //                    {this.state.user && <ManageUserForm save={this.saveUser} user={this.state.user}
        //                        primaryAccountTypes={this.props.primaryAccountTypes} />}
        //                </div>
        //            </div>
        //        </div>

        //        {this.state.user && this.state.user.Accounts && <div className="row mt-4">
        //            <div className={"col-12"}>
        //                <LinkedSapAccounts accounts={this.state.user.Accounts} userId={this.state.user.UserId}
        //                    getAccounts={getUserSapAccounts} deleteAccount={deleteUserSapAccount}
        //                    accountTypes={this.props.accountTypes} />
        //            </div>
        //        </div>
        //        }

        //        {this.state.user && this.state.user.PrimaryAccountTypeId === 3 && <div className="row mt-4">
        //            <div className={"col-12"}>
        //                <ExclusionList getExclusions={getExclusionList} updateExclusions={updateExclusionList}
        //                    userId={this.state.user.UserId} />
        //            </div>
        //        </div>
        //        }
        //        <div className={"row mt-4"}>
        //            <div className={"col"}>
        //                <span role={"button"} className={"font-button-icon"}
        //                    data-toggle="modal"
        //                    data-target="#confirmDelete">
        //                    <FontAwesomeIcon icon={"trash"} /> Delete User</span>
        //            </div>
        //        </div>
        //    </div>
        //);

        return (
            <div className={"container"}>
                <Modal show={this.state.show} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>{"Confirm Deletion"}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{"Are you sure you want to delete this use? This can not be undone."}</Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-primary buttonColor" data-dismiss="modal"
                            onClick={this.deleteUser}>
                            {"ok"}
                        </button>
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={this.handleClose}
                        >
                            Cancel
                        </button>
                    </Modal.Footer>
                </Modal>
                <div className="row">
                    <div className="col-4">
                        <Link to="/settings/users" className="btn button-back">
                            <i className="fas fa-angle-left button-back-text" /> &nbsp;
                            <span className="button-back-text">{"Back To Users"}</span>
                        </Link>
                    </div>
                    <div className="col-4 text-center">
                        <span className="user-name">Edit User</span>
                    </div>
                </div>
                {this.state.request && <div className="row mt-2">
                    <div className={"col-12"}>
                        <div className="card">
                            <RegistrationRequestDetails request={this.state.request} />
                        </div>
                    </div>
                </div>}
                <div className="row mt-2">
                    <div className={"col-12"}>
                        <div className="card">
                              {this.state.user && <ManageUserForm save={this.saveUser} user={this.state.user}
                                      primaryAccountTypes = { this.props.primaryAccountTypes } />}
                        </div>
                    </div>
                </div>

                {this.state.user && this.state.user.Accounts && <div className="row mt-4">
                    <div className={"col-12"}>
                        <LinkedSapAccounts accounts={this.state.user.Accounts} userId={this.state.user.UserId}
                            refreshAccounts={getUserSapAccounts}
                            getAccounts={getUserSapAccounts} deleteAccount={deleteUserSapAccount}
                            accountTypes={this.props.accountTypes}
                        />
                    </div>
                </div>
                }

                {this.state.user && this.state.user.PrimaryAccountTypeId === 3 && <div className="row mt-4">
                    <div className={"col-12"}>
                        <ExclusionList getExclusions={getExclusionList} updateExclusions={updateExclusionList}
                            userId={this.state.user.UserId} />
                    </div>
                </div>
                }
                <div className={"row mt-4"}>
                    <div className={"col"}>
                        {<span role={"button"} className={"font-button-icon"}
                            onClick={this.handleShow}
                        >
                            <FontAwesomeIcon icon={"trash"} /> {"Delete User"}
                        </span>
                        }
                    </div>
                </div>
            </div>
        );


    }
}

function mapStateToProps(state) {
    return {
        accountTypes: state.default.accountTypes,
        primaryAccountTypes: state.default.primaryAccountTypes,
    };
}

ManageUserPage.propTypes = {
    getUser: PropTypes.func,
    getRegistrationRequest: PropTypes.func,
    fromRequest: PropTypes.string,
};

export default withRouter(connect(
    mapStateToProps,
)(ManageUserPage));
